import { render } from "./ContactoForm.vue?vue&type=template&id=2d73e016"
import script from "./ContactoForm.vue?vue&type=script&lang=js"
export * from "./ContactoForm.vue?vue&type=script&lang=js"

import "./ContactoForm.vue?vue&type=style&index=0&id=2d73e016&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__